module.exports = "<div id=app-body @scroll=scrollHandler><v-section title=Profile><profile></profile></v-section><v-section title=Skills><skills></skills></v-section><v-section title=Experiences><experiences></experiences></v-section><v-section title=Education><education></education></v-section><v-section title=\"Hire Me!\"><hire-me></hire-me></v-section><v-section title=\"Online Demo\"><demo></demo></v-section><v-section title=Screenshots><screenshots></screenshots></v-section><div class=hint>* This profile page is still in Beta Version, Download and Print Feature is coming soon.</div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppBody.vue
 ** module id = 216
 ** module chunks = 0
 **/